import { Select, Tooltip, Typography } from 'antd';
import { ReactComponent as DownAngle } from 'assets/img/icons/DownAngle.svg';
import { ReactComponent as SelectInputDivider } from 'assets/img/SelectInputDivider.svg';
import { ReactComponent as Tick } from 'assets/img/icons/GreenDropdownTick.svg';
import styled from 'styled-components';
import classNames from 'classnames';
const { Text } = Typography;

interface SelectAntProps {
  options?: { value: string; label: JSX.Element | string }[];
  defaultValue?: { value: string; label: string } | number;
  value?: { value: string; label: string } | string | number | null;
  onChange?: (value: any) => void;
  onSelect?: (value: any, option: any) => void;
  disabled?: boolean;
  showSearch?: boolean;
  placeholder?: string;
  className?: string;
  optionFilterProp?: string;
  allowClear?: boolean;
  filterOption?: any;
  onClear?: () => void | boolean;
  defaultActiveFirstOption?: boolean;
  getPopupContainer?: () => HTMLElement;
  showTick?: boolean;
}
const Wrapper = styled.div`
  position: relative;
  .ant-select {
    .ant-select-selector {
      height: 44px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 38px !important;
      }
    }
  }
  .ant-select-dropdown {
    padding: 0px !important;
  }
  .ant-select-arrow {
    right: 18px !important;
  }
  .select-form-input span.ant-select-selection-item span svg {
    display: none !important;
  }
  .select-form-input span.ant-select-selection-item .ant-typography {
    color: #7e7e7e !important;
  }
  .select-form-input span.ant-select-selection-item span:nth-child(1) {
    margin: 0 !important;
  }
  .select-form-input span.ant-select-selection-item span:nth-child(2) {
    margin: 0 !important;
  }
  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    padding: 0 12px !important;
  }
  .ant-select-single.ant-select-open .ant-select-selection-item {
    color: #7e7e7e;
  }
`;
const SelectAnt: React.FC<SelectAntProps> = (props) => {
  const {
    defaultValue,
    disabled,
    onChange,
    options,
    value,
    onSelect,
    children,
    showSearch,
    placeholder,
    className,
    optionFilterProp,
    allowClear,
    filterOption,
    onClear,
    defaultActiveFirstOption,
    getPopupContainer,
    showTick,
  } = props;

  const optionsConverter = (
    options: { value: string; label: JSX.Element | string; id?: number }[],
    value: { value: string; label: string } | string | null,
  ) => {
    const newOptions = options.map((option) => {
      const isSelectedOption = option.value === value;
      return {
        ...(option.id && { id: option.id }),
        value: option.value,
        label: (
          <div>
            <span>
              <Tick style={{ opacity: `${isSelectedOption ? '1' : '0'}` }} />
            </span>
            <span style={{ marginLeft: '9px' }}>
              <Tooltip title={option.label}>
                <Text
                  className={classNames('', { optionActive: isSelectedOption })}
                  style={{ width: 'calc(100vw - 91vw)' }}
                  ellipsis={{ tooltip: option.label }}
                >
                  {option.label}
                </Text>
              </Tooltip>
            </span>
          </div>
        ),
      };
    });
    return newOptions;
  };
  let updatedOptions;
  if (options && value && showTick) {
    updatedOptions = optionsConverter(options, value.value);
  }

  return (
    <Wrapper className="select-wrapper">
      <Select
        virtual={false}
        defaultValue={defaultValue}
        getPopupContainer={getPopupContainer ? getPopupContainer : () => document.querySelectorAll('.select-wrapper')[0] as HTMLElement}
        disabled={disabled}
        value={value}
        popupClassName="forms-ant-select-menu"
        className={`select-form-input ${className ? className : ''}`}
        style={{ width: '100%' }}
        suffixIcon={
          <span style={{ display: 'flex', alignItems: 'center', gap: '9px' }}>
            <SelectInputDivider />
            <DownAngle />
          </span>
        }
        onChange={onChange}
        options={updatedOptions ?? options}
        onSelect={onSelect}
        showSearch={showSearch}
        placeholder={placeholder}
        optionFilterProp={optionFilterProp}
        allowClear={allowClear}
        filterOption={filterOption}
        onClear={onClear}
        defaultActiveFirstOption={defaultActiveFirstOption}
      >
        {children}
      </Select>
    </Wrapper>
  );
};

export default SelectAnt;
